import { Injectable, QueryList } from '@angular/core';
import { D3ModalDialogComponent } from '../popups/modal-dialog/modal-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class D3ComponentsUtil {
  // constructor() {}

  closeAllDialogs(modalDialogs: QueryList<D3ModalDialogComponent>) {
    modalDialogs.forEach((dialog) => {
      if (dialog.isOpen) {
        dialog.closeModal();
      }
    });
  }

  anyDialogsOpen(modalDialogs: QueryList<D3ModalDialogComponent>): boolean {
    return modalDialogs.some((dialog) => dialog.isOpen);
  }

  triggerOpenModal(
    modalDialogs: QueryList<D3ModalDialogComponent>,
    uniqueId: string,
    calloutVariant: string = null,
    closeActiveDialogs = false,
    autoOpen = false
  ) {
    // Find the specific modal dialog instance with the given uniqueId
    const dialogId = uniqueId;
    const targetDialog = modalDialogs.find((dialog) => dialog.uniqueId === dialogId);
    if (closeActiveDialogs) {
      this.closeAllDialogs(modalDialogs); //if there are existing dialogs, ensure they are closed.
    }
    if (targetDialog) {
      //autoOpen is a flag to indicate dialog that is not triggered by button (by event or on delay)
      targetDialog.openModal(calloutVariant, null, autoOpen);
    }
  }
}
